export default __webpack_public_path__ + "images/student/avatars/Uno-ede676d1ae962badfe40fa65369adab4.svg";